"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
const react_1 = __importDefault(require("react"));
class FormField extends react_1.default.Component {
    get value() {
        return this.props.config.value();
    }
    get wrapperProps() {
        return {
            label: this.props.label,
            description: this.props.description,
            errors: this.props.config.errors,
            className: this.props.className
        };
    }
    setValue(value) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.props.config.setValue(() => value);
        });
    }
}
exports.FormField = FormField;
//# sourceMappingURL=FormField.js.map